// removed by extract-text-webpack-plugin
module.exports = {"root":"_khdl9","header":"_3gdjp","headerContent":"_moAG1","description":"_1u3-9","icon":"_p81-Z","heading":"__x2hP","link":"_3bEQ8","body":"_PUwzM"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/SubSection/SubSection.scss
// module id = 1314
// module chunks = 3